import useResetPasswordDataDecorator from './useResetPasswordDataDecorator';
export default useResetPasswordDataDecorator;
